<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="search-modal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-search"></i>
                        検索と置換
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>検索</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button class="btn btn-secondary btn-sm" type="button" @click="find(true)" :disabled="keyword.length == 0">
                                    この本文を検索
                                </button>
                            </div>
                            <input type="search" id="keyword" class="form-control" v-model="keyword"
                                :placeholder="placeholder"
                                @focus="select('keyword')"
                                @keydown.enter="keydown($event)" />
                            <div class="input-group-append">
                                <button class="btn btn-secondary btn-sm" type="button" @click="find()" :disabled="keyword.length == 0">
                                    この小説を検索
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" v-if="results.length">
                        <label>置換</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button class="btn btn-danger btn-sm" type="button" @click="replaceAll(true)" :disabled="disabled || replace.length == 0">
                                    この本文を置換
                                </button>
                            </div>
                            <input type="text" id="replace" class="form-control" v-model="replace"
                                placeholder="置換文字列"
                                @focus="select('replace')" />
                            <div class="input-group-append">
                                <button class="btn btn-danger btn-sm" type="button" @click="replaceAll()" :disabled="disabled || replace.length == 0 || is_episode">
                                    この小説を置換
                                </button>
                            </div>
                        </div>
                        <div class="text-danger small mt-2">
                            検索結果を指定文字列で置換します。
                            <div v-if="disabled">
                                置換を行うには、先に編集中の本文を保存してください。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-body" v-if="finded || results.length || histories.length">
                    <ul class="nav nav-tabs mb-2">
                        <li class="nav-item">
                            <a href="#" class="nav-link" :class="{active: panel == 0}" @click.prevent="panel = 0">
                                <i class="fas fa-search"></i>
                                検索結果
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="#" class="nav-link" :class="{active: panel == 1}" @click.prevent="panel = 1">
                                <i class="fas fa-history"></i>
                                置換履歴
                            </a>
                        </li>
                    </ul>
                    <div class="list-group" v-if="panel == 0">
                        <router-link :to="`/mypage/book/${book_id}/section/edit/${r.id}?pos=${r.pos}&len=${keyword.length}`"
                            class="list-group-item list-group-item-action small"
                            @click="closeModal()"
                            v-for="r in results" :key="r.ndx">
                            <div class="d-inline-block" :class="{
                                'text-primary': r.id != section_id,
                                'text-warning': r.id == section_id,
                            }" :title="r.section_name" data-toggle="tooltip">
                                <i class="fas fa-pen" v-if="r.id == section_id"></i>
                                {{$filters.truncate(r.section_name, 9)}}
                            </div>
                            <div class="d-inline-block" v-html="result(r.sample)"></div>
                        </router-link>
                        <div v-if="results.length == 0" class="small p-3">
                            <span v-if="finded">{{finded}} の</span>検索結果はありません。
                        </div>
                    </div>
                    <div v-else>
                        <div class="list-group" v-if="histories.length">
                            <a href="#" class="list-group-item list-group-item-action small d-flex justify-content-between"
                                v-for="h in histories" :key="h.cached_at"
                                @click="reset(h)">
                                <div>
                                    {{h.keyword}} → {{h.replace}}
                                    <span class="badge badge-primary bagde-pills">
                                        {{h.episodes.length}} 話
                                    </span>
                                </div>
                                <div>
                                    {{h.cached_at}}
                                </div>
                            </a>
                        </div>
                        <div v-else class="small p-3">
                            置換履歴はありません。
                        </div>
                        <div class="small py-2 text-right">
                            最大 {{$store.state.max_histories}} 件まで保存します。
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.section {
    font-size: 1.1rem;
}
</style>

<script>
import Dexie from "dexie";
export default {
    props: {
        book_id: {
            required: true,
        },
        section_id: {
            default: null,
        },
        disabled: {
            default: false,
        },
    },
    data() {
        return {
            keyword: "",
            replace: "",
            results: [],
            grepdb: null,
            histories: [],
            panel: null,
            finded: null,
            is_episode: false,
        }
    },
    methods: {
        clear() {
            this.keyword = "";
            this.replace = "";
            this.finded = "";
            this.results = [];
        },
        keydown(ev) {
            if (ev && ev.keyCode === 13) {
                if (ev.ctrlKey || ev.metaKey) {
                    this.find(true);
                } else {
                    this.find();
                }
            }
        },
        find(is_episode = false) {
            if (this.keyword.length == 0) return;
            $('[data-toggle="tooltip"]').tooltip("dispose");
            this.is_episode = is_episode;
            axios.get("/mypage/book/search", { params: {
                keyword: this.keyword,
                book_id: this.book_id,
                section_id: is_episode ? this.section_id : null,
            }}).then(res => {
                let rc = res.data;
                let ndx = 1;
                const regex = new RegExp(this.keyword.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'), "ug");
                try {
                    this.results = [];
                    for (let r of rc) {
                        let rows = r.body.split(/\n/u);
                        let chars = 0;
                        for (let row of rows) {
                            let pos;
                            while(pos = regex.exec(row)) {
                                let sample = "";
                                if (pos) {
                                    if (pos.index > 15) {
                                        sample = "…" + row.substr(pos.index - 15);
                                    } else {
                                        sample = row;
                                    }
                                    if (sample.length > 50) {
                                        sample = sample.substr(0, 50) + "…";
                                    }
                                    this.results.push({
                                        ndx: ndx++,
                                        section_name: r.section_name || "（無題）",
                                        sample: sample,
                                        id: r.id,
                                        pos: chars + pos.index,
                                    });
                                }
                            }
                            chars += row.length + 1;
                        }
                    }
                    this.finded = this.keyword;
                    setTimeout(() => {$('[data-toggle="tooltip"]').tooltip()});
                    this.panel = 0;
                } catch (error) {
                    console.error(error);
                }
            }).catch(err => { alert.err(err.response) });
        },
        replaceAll(is_episode = false) {
            axios.post("/mypage/book/replace", {
                book_id: this.book_id,
                keyword: this.keyword,
                section_id: is_episode ? this.section_id : null,
                replace: this.replace,
            }).then(res => {
                // 編集前のエピソードリストを保存
                this.grepdb.histories.put({
                    cached_at: moment().format("YYYY-MM-DD HH:mm:ss"),
                    book_id: this.book_id,
                    episodes: res.data,
                    keyword: this.keyword,
                    replace: this.replace,
                }).then(res => {
                    this.grepdb.histories.where("book_id").equals(this.book_id).count(count => {
                        if (count > this.$store.state.max_histories) {
                            this.grepdb.histories.reverse().offset(this.$store.state.max_histories).delete().then(res => {
                                this.loadHistories();
                            });
                        } else {
                            this.loadHistories();
                        }
                    });
                }).catch(err => { alert.err(err) });
                this.results = [];
                this.replace = "";
                this.$emit("reload");
                this.closeModal();
                alert.msg("すべて置換しました。");
            }).catch(err => { alert.err(err.response) });
        },
        result(body) {
            const regex = new RegExp('(' + this.keyword.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&') + ')', "ug");
            return body.replace(regex, "<b>$1</b>");
        },
        closeModal() {
            $("#search-modal").modal("hide");
        },
        select(id) {
            $("#" + id).select();
        },
        loadHistories() {
            this.grepdb.histories.where("book_id").equals(this.book_id).reverse().toArray((res) => {
                this.histories = res;
            });
        },
        reset(h) {
            // 指定履歴までの全ての履歴をマージ
            let merge = [];
            for (const history of _.orderBy(this.histories, 'cached_at', 'asc')) {
                if (moment(history.cached_at).isSameOrAfter(moment(h.cached_at))) {
                    for (const episode of history.episodes) {
                        if (!_.find(merge, {id: episode.id})) {
                            merge.push(episode);
                        }
                    }
                }
            }
            Swal.fire({
                title: "一括置換をもとに戻す",
                html: `<div class='small text-left'>
                    一括置換<b>「${h.keyword} → ${h.replace}」</b>を元に戻します。<br>
                    この置換処理以前の状態に戻ります。
                    置換処理後に編集した内容は全て破棄されます。<br>
                    よろしいですか？
                    </div>`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "<i class='fas fa-history'></i>もとに戻す",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/book/reset", {episodes: merge}).then(res => {
                        alert.msg(res.data);
                        this.clear();
                        this.grepdb.histories.where("cached_at").aboveOrEqual(h.cached_at).delete();
                        this.$emit("reload");
                        this.closeModal();
                    })
                }
            });
        },
    },
    watch: {
        keyword(n, o) {
            if (o.length > 0 && n.length === 0) {
                this.clear();
            }
        }
    },
    computed: {
        placeholder() {
            if (navigator.userAgent.match(/Macintosh/)) {
                return "検索文字列（Enterで検索、⌘+Enterで本文検索）";
            } else {
                return "検索文字列（Enterで検索、Ctrl+Enterで本文検索）";
            }
        }
    },
    mounted() {
        // 履歴DB
        this.grepdb = new Dexie("grepdb");
        this.grepdb.version(1).stores({histories: "cached_at, book_id"});
        $("#search-modal").on("shown.bs.modal", (e) => {
            this.panel = 0;
            $("#keyword").focus();
            setTimeout(() => { $("#keyword").focus(); }, 500);
            this.loadHistories();
        });
    }
}
</script>